export default __webpack_public_path__ + "static/avocat-coentreprise-affaires-9ffd1637329f09b98ba7de2932e79c02.jpg";